// Animated transition for the Advanced Search toggle.
//
// On toggle click we play a short exit animation (current content fades /
// slides out), set a single-use sessionStorage flag, then navigate. The
// destination page reads the flag synchronously (inline script at the top of
// the view) and plays the CSS entry animation. See
// docs/superpowers/specs/2026-06-08-search-advanced-toggle-transition-design.md

const EXIT_MS = 200;
const ENTRY_CLASS = "search-transitioning-in";
// keep in sync with searchSlideIn / filterSlideIn in application.scss
const ENTRY_MS = 300;
const EXIT_TARGET_IDS = [
  "filter-section-content",
  "search-results-content",
  "adv-content",
];

// The entry animations fill forwards, so their final transform stays applied for
// as long as the class is on <html> — and an element with any transform is the
// containing block for its position:fixed descendants. Left on, #adv-content
// traps every fixed overlay rendered inside the results (save/unsave comment,
// alert admin, Flowbite modal panels) inside the content column instead of the
// viewport. Dropping the class once the animation is done restores transform:none.
function clearEntryClass() {
  const root = document.documentElement;
  if (!root.classList.contains(ENTRY_CLASS)) return;

  const done = () => root.classList.remove(ENTRY_CLASS);
  EXIT_TARGET_IDS.forEach((id) => {
    document.getElementById(id)?.addEventListener("animationend", done, { once: true });
  });
  // Reduced motion sets animation:none, so animationend never fires.
  setTimeout(done, ENTRY_MS + 100);
}

export function initSearchTransition() {
  clearEntryClass();

  const toggle = document.querySelector(".search-adv-toggle");
  if (!toggle) return;

  toggle.addEventListener("click", (e) => {
    const href = toggle.getAttribute("href");
    if (!href) return;
    e.preventDefault();

    // Flag the next page load as a toggle transition (single-use; cleared on read).
    try {
      sessionStorage.setItem("searchTransition", "1");
    } catch (_) {
      // sessionStorage unavailable (private mode / blocked) — degrade gracefully.
    }

    EXIT_TARGET_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.add("search-exit");
    });

    setTimeout(() => {
      window.location.href = href;
    }, EXIT_MS);
  });
}
